import React from 'react'

const Skeleton = () => {
    return (
        <div className="border border-[#43AAD5] rounded-md p-5 bg-black animate-pulse">
            <div className="flex justify-between items-start">
                <div className="h-6 w-24 bg-gray-700 rounded"></div>
                <ul>
                    <li className="h-8 w-8 bg-gray-700 rounded mb-2"></li>
                    <li className="h-8 w-8 bg-gray-700 rounded"></li>
                </ul>
            </div>
            <div className="flex items-center justify-center mt-5">
                <div className="w-full h-[230px] bg-gray-700 rounded"></div>
            </div>
            <div className="flex justify-center gap-3 mt-5">
                <div className="h-5 w-12 bg-gray-700 rounded"></div>
                <div className="h-7 w-16 bg-gray-700 rounded"></div>
            </div>
            <div className="flex justify-center items-center mt-5 mb-5 gap-3">
                <div className="h-9 w-16 bg-gray-700 rounded-full"></div>
                <div className="h-9 w-16 bg-gray-700 rounded-full"></div>
            </div>
            <div className="h-[50px] w-full bg-gray-700 rounded-full"></div>
        </div>
    );
}

export default Skeleton